import MicroModal from 'micromodal';

export default {

	init() {
		console.log('modals init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
		window.addEventListener("load", this.bindLoadEvents);
	},

	bindEvents() {
		$('template[data-js=modal]').each(function (index, elem) {
			var modal = elem.content.firstElementChild.cloneNode(true);
			document.body.appendChild(modal);
			elem.remove();
		});

		Modal.bindModalEvents();
	},

	bindModalEvents() {
		if (!$('[data-micromodal-trigger]').length) {
			return;
		}

		$('[data-micromodal-trigger]').on('click', function (e) {
			e.preventDefault();
		});

		MicroModal.init({
			onShow: Modal.show,
			onClose: Modal.close,
			disableFocus: false,
			disableScroll: true
		});
	},

	bindLoadEvents() {
		const hash = window.location.hash;
		const modalId = hash.substring(1);
		let target = document.getElementById(modalId);

		if(!target || !target.classList.contains('sh-modal')) {
			return;
		}

		setTimeout(function() {
			MicroModal.show(modalId, {
				onShow: Modal.show,
				onClose: Modal.close,
				disableFocus: true,
				disableScroll: true
			});
		}, 2000);


	},

	show(modal, trigger, event) {
		$('html').addClass('has-modal-open').addClass('is-modal-open');
		Modal.loadVideo(modal);
		Modal.updateUrl('#'+modal.getAttribute('id'));
		Sliders.toggleTicker('pause');
	},

	close(modal, trigger, event) {
		$('html').removeClass('has-modal-open').removeClass('is-modal-open');
		Modal.unloadVideo(modal);
		Modal.updateUrl(window.location.href.split('#')[0]);
		Sliders.toggleTicker('play');
	},

	updateUrl(url) {
		if(window.history.pushState) {
			window.history.pushState({}, '', url);
		}
	},

	loadVideo(modal) {
		const elem = modal.querySelector('[data-modal-video-url]');

		if(!elem) {
			return;
		}

		let url = elem.dataset.modalVideoUrl;
		url += url.indexOf('?') ? '&autoplay=1' : '?autoplay=1';

		let template = `<iframe class="w-full h-full absolute inset-0" src="${url}" loading="lazy"  width="800" height="450" frameborder="0" allowfullscreen allowautoplay allow="fullscreen;autoplay"></iframe>`;
		elem.insertAdjacentHTML('beforeend', template);
	},

	unloadVideo(modal) {
		const elem = modal.querySelector('[data-modal-video-url]');

		if(!elem) {
			return;
		}

		elem.innerHTML = '';
	},

};
